import { useFormContext, Controller } from 'react-hook-form'
import { RadioButtonGroup, RadioButton } from '@cb/apricot-react'
import { CBInputMethod } from '@cb/apricot'
import { useEffect } from 'react'
import {
  FIELD_GENDER,
  VALUE_FEMALE,
  VALUE_MALE,
  VALUE_ANOTHER_GENDER,
  ERROR_GENDER,
} from '../constants'

function Gender({ disabled, disableThirdOption }) {
  const { control, watch, setValue, setError, clearErrors } = useFormContext()
  const genderVal = watch(FIELD_GENDER)

  useEffect(() => {
    CBInputMethod()
  }, [])

  useEffect(() => {
    if (disableThirdOption) {
      if (genderVal !== VALUE_MALE && genderVal !== VALUE_FEMALE) {
        setValue(FIELD_GENDER, '')
        setError(ERROR_GENDER, {
          type: 'Gender Error',
          message: 'Please select an available gender option above.',
        })
      }
    }
  }, [disableThirdOption, genderVal, setError, setValue])

  return (
    <>
      <Controller
        control={control}
        name={FIELD_GENDER}
        rules={{ required: 'Gender must be selected' }}
        disabled={disabled}
        render={({ field: { onChange, onBlur, value, disabled, name } }) => (
          <RadioButtonGroup
            name={name}
            legend="Gender"
            required
            vertical={true}
            onChange={value => {
              onChange(value)
              clearErrors(ERROR_GENDER)
            }}
            value={value}
          >
            <RadioButton
              name={name}
              label="Female"
              value={VALUE_FEMALE}
              disabled={disabled}
              onBlur={value => onBlur(value)}
            />
            <RadioButton
              name={name}
              label="Male"
              value={VALUE_MALE}
              disabled={disabled}
              onBlur={value => onBlur(value)}
            />
            {!disableThirdOption ? (
              <RadioButton
                name={name}
                label="Skip this Question"
                value={VALUE_ANOTHER_GENDER}
                disabled={disabled}
                onBlur={value => onBlur(value)}
              />
            ) : null}
          </RadioButtonGroup>
        )}
      />
    </>
  )
}

export default Gender
